import { AriaAttributes, ReactElement, ReactNode } from "react";

/*
  Compound reference components used to build the table collection.
  They are not rendered, but used to parse the table structure.
*/

type TableColumnElement = ReactElement<TableColumnProps, typeof TableColumn>;
type TableRowElement = ReactElement<TableRowProps, typeof TableRow>;
type TableCellElement = ReactElement<TableCellProps, typeof TableCell>;

export interface TableHeaderProps {
  children: TableColumnElement | TableColumnElement[];
  isHidden?: boolean;
}

export interface TableColumnProps {
  id: string;
  children: ReactNode;
  "aria-sort"?: AriaAttributes["aria-sort"];
}

export interface TableBodyProps {
  children: TableRowElement | TableRowElement[];
}

export interface TableRowProps {
  key?: string | number;
  children: TableCellElement | TableCellElement[];
  onClick?: () => void;
}

export interface TableCellProps {
  columnKey?: string;
  children?: ReactNode;
  colSpan?: number;
}

// Type-safe component definitions that enforce proper children
export const TableHeader = ({ ...props }: TableHeaderProps) => {
  return null; // This is just a marker component for parsing
};

export const TableColumn = ({ ...props }: TableColumnProps) => {
  return null; // This is just a marker component for parsing
};

export const TableBody = ({ ...props }: TableBodyProps) => {
  return null; // This is just a marker component for parsing
};

export const TableRow = ({ ...props }: TableRowProps) => {
  return null; // This is just a marker component for parsing
};

export const TableCell = ({ ...props }: TableCellProps) => {
  return null; // This is just a marker component for parsing
};
